/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//register global variable
const nameSpace = require('src/common/utils/nameSpace')

nameSpace('COMMON', "componentHub")

COMMON.componentHub = {
  dropMenu: [],
  inputBox: [],
  bubble: [],
  dataPicker: [],
  breadCrumb: [],
  selectTree: [],
  btn: []
}

require('./event/event')




// WEBPACK FOOTER //
// ./src/common/common.js